import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import AboutPage from './components/Pages/AboutPage';
import ContactPage from './components/Pages/ContactPage';
import ErrorPage from './components/Pages/ErrorPage';
import Home from './components/Pages/Home';
import PortfolioDetailsPage from './components/Pages/PortfolioDetailsPage';
import ServiceDetailsPage from './components/Pages/ServiceDetailsPage';
import ServicesPage from './components/Pages/ServicesPage';
import EquipmentPage from './components/Pages/EquipmentPage';
// import TeamPage from './components/Pages/TeamPage';
import PortfolioPage from './components/Pages/PortfolioPage';
// import TeamDetails from './components/Pages/TeamDetails';
// import PhotographyAgencyHome from './components/Pages/PhotographyAgencyHome';
// import CreativePortfolioHome from './components/Pages/CreativePortfolioHome';
import BtcChecker from './components/Pages/BtcChecker';
import CalendarPage from './components/Pages/CalendarPage';
import BookingEditor from './components/BookingEditor';
// import DigitalAgencyHome from './components/Pages/DigitalAgencyHome';
// import MarketingAgencyHome from './components/Pages/MarketingAgencyHome';
// import ShowcasePortfolioHome from './components/Pages/ShowcasePortfolioHome';
// import CaseStudyShowcaseHome from './components/Pages/CaseStudyShowcaseHome';
import Layout from './components/Layout';
// import CaseStudyDetailsPage from './components/Pages/CaseStudyDetailsPage';
import FaqPage from './components/Pages/FaqPage';
// import FreelancerAgencyHome from './components/Pages/FreelancerAgencyHome';
// import ArchitectureAgencyHome from './components/Pages/ArchitectureAgencyHome';
// import CreativeSolutionHome from './components/Pages/CreativeSolutionHome';
// import PersonalPortfolioHome from './components/Pages/PersonalPortfolioHome';
// import VideoShowcaseHome from './components/Pages/VideoShowcaseHome';
import ReactGA from 'react-ga';

function App() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          {/* <Route
            path="photography-agency"
            element={<PhotographyAgencyHome />}
          /> */}
          {/* <Route path="digital-agency" element={<DigitalAgencyHome />} />
          <Route path="marketing-agency" element={<MarketingAgencyHome />} />
          <Route path="freelancer-agency" element={<FreelancerAgencyHome />} />
          <Route
            path="architecture-agency"
            element={<ArchitectureAgencyHome />}
          />
          <Route path="creative-solution" element={<CreativeSolutionHome />} />
          <Route
            path="personal-portfolio"
            element={<PersonalPortfolioHome />}
          /> */}
          <Route path="ostudiu" element={<AboutPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="sluzby" element={<ServicesPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="btc" element={<BtcChecker />} /> 
          <Route path="kalendar" element={<CalendarPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="editor-rezervaci" element={<BookingEditor />} />
          <Route path="booking-editor" element={<BookingEditor />} />
          <Route path="cenik" element={<ServicesPage id="cenik"/>}  />
          <Route path="vybaveni" element={<EquipmentPage />} />
          
          <Route
            path="sluzby/:serviceDetailsId"
            element={<ServiceDetailsPage />}
          />
          <Route
            path="service/:serviceDetailsId"
            element={<ServiceDetailsPage />}
          />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route
            path="portfolio/:portfolioDetailsId"
            element={<PortfolioDetailsPage />}
          />
          <Route path="aktuality" element={<Navigate to="/" replace />} />
          <Route path="aktuality/:newsId" element={<Navigate to="/" replace />} />
          <Route path="kontakt" element={<ContactPage />} />
          <Route path="contact" element={<ContactPage />} />
          {/* <Route path="team" element={<TeamPage />} />
          <Route path="team/:teamDetails" element={<TeamDetails />} /> */}
          {/* <Route
            path="/case-study/:caseStudyDetailsId"
            element={<CaseStudyDetailsPage />}
          /> */}
          <Route path="faq" element={<FaqPage />} />
        </Route>
        <Route path="en" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="btc" element={<BtcChecker />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="booking-editor" element={<BookingEditor />} />
          <Route path="pricing" element={<ServicesPage id="cenik" />} />
          <Route path="equipment" element={<EquipmentPage />} />
          <Route
            path="services/:serviceDetailsId"
            element={<ServiceDetailsPage />}
          />
          <Route
            path="service/:serviceDetailsId"
            element={<ServiceDetailsPage />}
          />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route
            path="portfolio/:portfolioDetailsId"
            element={<PortfolioDetailsPage />}
          />
          <Route path="news" element={<Navigate to="/en" replace />} />
          <Route path="news/:newsId" element={<Navigate to="/en" replace />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="faq" element={<FaqPage />} />
        </Route>
        <Route
          path="/"
          element={<Layout headerVariant="cs-site_header_full_width" />}
        >
          {/* <Route
            path="creative-portfolio"
            element={<CreativePortfolioHome />}
          />
          <Route
            path="showcase-portfolio"
            element={<ShowcasePortfolioHome />}
          />
          <Route
            path="case-study-showcase"
            element={<CaseStudyShowcaseHome />}
          />
          <Route path="video-showcase" element={<VideoShowcaseHome />} /> */}
        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
